<template>
  <div class="products-individuals-wrapper">
    <IndividualsHeader :el="'pb'" />
    <div class="text-group">
      <h3 class="text-pb">{{ $t('products-pb-1') }}</h3>
      <p>{{ $t('products-pb-2') }}</p>
      <p>{{ $t('products-pb-3') }}</p>
    </div>
    <Gallery :gallery="gallery" />
    <div class="content-row">
      <Dropdown
        :id="'pbDropdownOne'"
        :color="color"
        :title="$t('products-pb-dd1-1')"
        :content="dropdownOne"
        :open="true"
      />
    </div>
    <!-- <div class="content-row" id="alloysElement">
      <Dropdown
        :id="'pbDropdownTwo'"
        :color="color"
        :title="$t('products-pb-dd2-1')"
        :content="dropdownTwo"
        :open="true"
      />
    </div>-->
    <div class="content-row">
      <Dropdown
        :id="'pbDropdownThree'"
        :color="color"
        :title="$t('products-pb-dd3-1')"
        :content="dropdownThree"
        :open="true"
      />
    </div>
    <!-- <div class="content-row">
      <Dropdown
        :id="'pbDropdownFour'"
        :color="color"
        :title="$t('products-pb-dd4-1')"
        :content="dropdownFour"
        :open="true"
      />
    </div>-->
    <div class="content-row">
      <Dropdown
        :id="'pbDropdownFive'"
        :color="color"
        :title="$t('products-pb-dd5-1')"
        :content="dropdownFive"
        :open="true"
      />
    </div>
    <!-- <div class="content-row">
      <Dropdown
        :id="'pbDropdownSix'"
        :color="color"
        :title="$t('products-pb-dd6-1')"
        :content="dropdownSix"
        :open="true"
      />
    </div>-->
    <!-- <div class="content-row">
      <Dropdown
        :id="'pbDropdownSeven'"
        :color="color"
        :title="$t('products-pb-dd7-1')"
        :content="dropdownSeven"
        :open="true"
      />
    </div>-->
    <div class="content-row">
      <Dropdown
        :id="'pbDropdownEight'"
        :color="color"
        :title="$t('products-pb-dd8-1')"
        :content="dropdownEight"
        :open="true"
      />
    </div>
    <div class="content-row">
      <Dropdown
        :id="'pbDropdownNine'"
        :color="color"
        :title="$t('products-pb-dd9-1')"
        :content="dropdownNine"
        :open="true"
      />
    </div>
    <div class="content-row">
      <Files :color="color" :files="files" />
    </div>
    <InterestingFacts :title="$t('products-pb-if-title')" :facts="facts" :color="color" />
  </div>
</template>

<script>
import IndividualsHeader from "./shared/IndividualsHeader";
import InterestingFacts from "./shared/InterestingFacts";
import Dropdown from "./shared/Dropdown";
import Gallery from "./shared/Gallery";
import Files from "./shared/Files";

export default {
  components: {
    IndividualsHeader,
    InterestingFacts,
    Dropdown,
    Gallery,
    Files
  },
  props: ["color"],
  data() {
    return {
      gallery: [
        {
          type: "video",
          url: require("../../../assets/img/products/pb/pb_gallery_1.mp4")
        },
        {
          type: "image",
          url: require("../../../assets/img/products/pb/pb_gallery_2.jpg")
        },
        {
          type: "image",
          url: require("../../../assets/img/products/pb/pb_gallery_3.jpg")
        },
        {
          type: "image",
          url: require("../../../assets/img/products/pb/pb_gallery_4.gif")
        },
        {
          type: "image",
          url: require("../../../assets/img/products/pb/pb_gallery_5.jpg")
        }
      ],
      files: {
        bg: [
          "Брошура КЦМ Олово.pdf",
          "Олово-Информационен лист за безопасност.pdf",
          "Масиви на метал олово-Информационен лист за безопасност.pdf"
        ],
        en: ["Brochure KCM Lead.pdf", "LEAD METAL SDS.pdf", "BiPb SDS.pdf"]
      }
    };
  },
  computed: {
    dropdownOne() {
      return {
        table: [
          [this.$t("brand"), "99.99"],
          [this.$t("elements"), "%"],
          [{ el: "Pb" }, "99.99 min."],
          [{ el: "Ag" }, "0.0015 max."],
          [{ el: "Cu" }, "0.0005 max."],
          [{ el: "Zn" }, "0.0002 max."],
          [{ el: "Cd" }, "0.0002 max."],
          [{ el: "Ni" }, "0.0002 max."],
          [{ el: "As" }, "0.0005 max."],
          [{ el: "Sb" }, "0.0005 max."],
          [{ el: "Sn" }, "0.0005 max."],
          [{ el: "Bi" }, "0.01 max."]
        ],
        columns: {
          titles: [this.$t("products-pb-dd1-2")],
          left: [
            {
              img: require("../../../assets/img/products/pb/dd1_scheme.svg")
            },
            {
              title: this.$t("products-pb-dd1-3"),
              texts: [this.$t("products-pb-dd1-4")]
            }
          ],
          right: [
            {
              spec: {
                title: this.$t("products-dd-1"),
                mass: "47 +/- 3 kg",
                left: this.$t("products-dd-3"),
                right: this.$t("products-dd-5"),
                l: "575-590 mm",
                w: "100-107 mm",
                h: "85-95 mm"
              }
            },
            {
              spec: {
                title: this.$t("products-dd-2"),
                mass: "1320-1470 kg",
                left: this.$t("products-dd-4"),
                right: this.$t("products-dd-5"),
                l: "575-590 mm",
                w: "575-590 mm",
                h: "510-580 mm"
              }
            },
            {
              title: this.$t("products-pb-dd1-5"),
              texts: [this.$t("products-pb-dd1-6")]
            }
          ]
        }
      };
    },
    // dropdownTwo: {
    //   table: [
    //     [this.$t("brand"), "99.99", "99.97"],
    //     [this.$t("elements"), "%", "%"],
    //     [{ el: "Pb" }, "99.99 min.", "99.97 min."],
    //     [{ el: "Ag" }, "0.001 max.", "0.0015 max."],
    //     [{ el: "Cu" }, "0.001 max.", "0.0015 max."],
    //     [{ el: "Zn" }, "0.001 max.", "0.0015 max."],
    //     [{ el: "Fe" }, "0.001 max.", "0.001 max."],
    //     [{ el: "As" }, "0.001 max.", "0.002 max."],
    //     [{ el: "Sb" }, "0.001 max.", "0.005 max."],
    //     [{ el: "Sn" }, "0.001 max.", "0.001 max."],
    //     [{ el: "Bi" }, "0.005 max.", "0.015 max."]
    //   ]
    // },
    dropdownThree() {
      return {
        table: [
          [this.$t("elements"), "%"],
          [{ el: "Bi" }, "7.0 min."],
          [{ el: "Ag" }, "0.01 max."],
          [{ el: "Cu" }, "0.05 max."],
          [{ el: "Sb" }, "0.002 max."],
          [{ el: "Sn" }, "0.001 max."],
          [{ el: "Mg" }, "0.001 max."],
          [{ el: "Pb" }, this.$t("products-dd-6")]
        ],
        columns: {
          left: [
            {
              img: require("../../../assets/img/products/pb/dd3.jpg")
            }
          ],
          right: [
            {
              spec: {
                title: this.$t("products-dd-1"),
                mass: "650 - 810 kg",
                left: this.$t("products-dd-3"),
                right: this.$t("products-dd-5"),
                l: "650 - 810 kg",
                w: "645 mm",
                h: "175 mm"
              }
            },
            {
              title: this.$t("products-pb-dd3-2"),
              texts: [this.$t("products-pb-dd3-3")]
            }
          ]
        }
      };
    },
    // dropdownFour: {
    //   table: [
    //     [this.$t("brand"), "PbSb 6.0 AsCu", "PbSb 5.0 AsCu"],
    //     [this.$t("elements"), "%", "%"],
    //     [{ el: "Sb" }, "5.90-6.10", "4.80-5.00"],
    //     [{ el: "As" }, "0.09-0.11", "0.05-0.07"],
    //     [{ el: "Cu" }, "0.045-0.055", "0.04-0.06"],
    //     [{ el: "Sn" }, "0.01 max.", "0.01 max."],
    //     [{ el: "Bi" }, "0.03 max.", "0.03 max."],
    //     [{ el: "Fe" }, "0.005 max.", "0.005 max."],
    //     [{ el: "Ni" }, "0.002 max.", "0.001 max."],
    //     [{ el: "Zn" }, "0.001 max.", "0.001 max."],
    //     [{ el: "S" }, "0.005 max.", "0.005"],
    //     [{ el: "Se" }, "0.005 max.", "-"],
    //     [{ el: "Pb" }, this.$t("products-dd-6"), this.$t("products-dd-6")]
    //   ],
    //   columns: {
    //     left: [
    //       {
    //         img: require("../../../assets/img/products/pb/dd4.jpg")
    //       }
    //     ],
    //     right: [
    //       {
    //         spec: {
    //           title: this.$t("products-dd-1"),
    //           mass: "40 - 45 kg",
    //           left: this.$t("products-dd-3"),
    //           right: this.$t("products-dd-5"),
    //           l: "588 mm",
    //           w: "108 mm",
    //           h: "75 mm"
    //         }
    //       },
    //       {
    //         title: this.$t("products-pb-dd3-2"),
    //         texts: [this.$t("products-pb-dd3-3")]
    //       }
    //     ]
    //   }
    // },
    dropdownFive() {
      return {
        // table: [
        //   [this.$t("brand"), "PbSb3", "PbSb4.5", "PbSb6.5"],
        //   [this.$t("elements"), "%", "%", "%"],
        //   [{ el: "Sb" }, "2-3.5", "4-4.5", "6-6.5"],
        //   [this.$t("products-dd-7"), "0.3 max.", "0.1 max.", "0.1 max."],
        //   [{ el: "Cu" }, "0.1 max.", "0.015 max.", "0.02 max."],
        //   [{ el: "As" }, "0.03 max.", "0.01 max.", "0.01 max."],
        //   [{ el: "Sn" }, "0.2 max.", "0.01 max.", "0.01 max."],
        //   [{ el: "Bi" }, "0.05 max.", "0.02 max.", "0,02 max."],
        //   [{ el: "Zn" }, "0.002 max.", "0.0015 max.", "0.001 max."],
        //   [{ el: "Fe" }, "0.01 max.", "0.003 max.", "0.003 max."],
        //   [
        //     { el: "Pb" },
        //     this.$t("products-dd-6"),
        //     this.$t("products-dd-6"),
        //     this.$t("products-dd-6")
        //   ]
        // ]
        columns: {
          left: [{ texts: [this.$t("products-pb-dd5-2")] }],
          right: [
            {
              img: require("../../../assets/img/products/pb/dd5.jpg")
            }
          ]
        }
      };
    },
    dropdownSix() {
      return {
        table: [
          [this.$t("brand"), "PbСа 0.06", "PbСа 0.12"],
          [this.$t("elements"), "%", "%"],
          [{ el: "Ca" }, "0.055 – 0.065", "0.09 – 0.12"],
          [{ el: "Sn" }, "0.87 – 0.093", "0.25 – 0.3"],
          [{ el: "Al" }, "0.005 – 0.009", "0.02 – 0.06"],
          [{ el: "Pb" }, this.$t("products-dd-6"), this.$t("products-dd-6")]
        ],
        columns: {
          left: [
            {
              img: require("../../../assets/img/products/pb/dd6.jpg")
            }
          ],
          right: [
            {
              spec: {
                title: this.$t("products-dd-1"),
                mass: "35 - 47 kg",
                left: this.$t("products-dd-3"),
                right: this.$t("products-dd-5"),
                l: "588 mm",
                w: "108 mm",
                h: "70 mm"
              }
            },
            {
              title: this.$t("products-pb-dd6-2"),
              texts: [this.$t("products-pb-dd6-3")]
            }
          ]
        }
      };
    },
    // dropdownSeven: {
    //   table: [
    //     [this.$t("brand"), "PbSb3Se", "Типичен анализ"],
    //     [this.$t("elements"), "%", "%"],
    //     [{ el: "Sb" }, "1-3.5", "1.85"],
    //     [{ el: "As" }, "0.15-0.2", "0.185"],
    //     [{ el: "Cu" }, "0.005-0.06", "0.056"],
    //     [{ el: "Se" }, "0.02-0.04", "0.038"],
    //     [{ el: "Sn" }, "0.005-0.1", "0.018"],
    //     [{ el: "Ag" }, "0.01 max.", "0.001"],
    //     [{ el: "Bi" }, "0.03 max.", "0.004"],
    //     [{ el: "Fe" }, "0.005 max.", "0.001"],
    //     [{ el: "Zn" }, "0.001 max.", "0.001"],
    //     [this.$t("products-dd-8"), "0.05", "-"],
    //     [
    //       { text: "Pb 99.99" },
    //       this.$t("products-dd-6"),
    //       this.$t("products-dd-6")
    //     ]
    //   ],
    //   columns: {
    //     left: [
    //       {
    //         img: require("../../../assets/img/products/pb/dd7.jpg")
    //       }
    //     ],
    //     right: [
    //       {
    //         spec: {
    //           title: this.$t("products-dd-1"),
    //           mass: "35 kg",
    //           left: this.$t("products-dd-3"),
    //           right: this.$t("products-dd-5"),
    //           l: "430 mm",
    //           w: "215 mm",
    //           h: "50 mm"
    //         }
    //       },
    //       {
    //         title: this.$t("products-pb-dd7-2"),
    //         texts: [this.$t("products-pb-dd7-3")]
    //       }
    //     ]
    //   }
    // },
    dropdownEight() {
      return {
        table: [
          [this.$t("brand"), "K - 16", "К - 83"],
          [this.$t("elements"), "%", "%"],
          [{ el: "Sb" }, "15 - 17", "10 - 12.5"],
          [{ el: "Sn" }, "15 - 17", this.$t("products-dd-6")],
          [{ el: "Cu" }, "1.5 - 2", "5.5 - 6.5"],
          [{ el: "As" }, "0.2", "0.08"],
          [{ el: "Fe" }, "0.08", "0.09"],
          [{ el: "Zn" }, "0.06", "0.02"],
          [{ el: "Bi" }, "0.09", "0.05"],
          [{ el: "Ag" }, "0.015", "0.01"],
          [{ el: "Pb" }, this.$t("products-dd-6"), "-"],
          [this.$t("products-dd-9"), "0.60", "0.30"]
        ],
        columns: {
          left: [
            {
              img: require("../../../assets/img/products/pb/dd8.jpg")
            }
          ],
          right: [
            {
              spec: {
                title: this.$t("products-dd-1"),
                mass: "7,5-12 kg",
                left: this.$t("products-dd-3"),
                right: this.$t("products-dd-5"),
                l: "415 mm",
                w: "105 mm",
                h: "30 mm"
              }
            },
            {
              title: this.$t("products-pb-dd8-2"),
              texts: [
                this.$t("products-pb-dd8-3"),
                this.$t("products-pb-dd8-4"),
                this.$t("products-pb-dd8-5")
              ]
            }
          ]
        }
      };
    },
    dropdownNine() {
      return {
        table: [
          [
            this.$t("brand"),
            `${this.$t("products-pb-dd9-5")} 30`,
            `${this.$t("products-pb-dd9-5")} 30 - 2`,
            `${this.$t("products-pb-dd9-5")} 33`,
            `${this.$t("products-pb-dd9-5")} 33 - 2`
          ],
          [this.$t("elements"), "%", "%", "%", "%"],
          [{ el: "Sn" }, "29 - 30", "29 - 30", "32 - 33", "32 - 33"],
          [{ el: "Sb" }, "1.5 - 2", "1.5 - 2", "-", "-"],
          [
            { el: "Pb" },
            this.$t("products-dd-6"),
            this.$t("products-dd-6"),
            this.$t("products-dd-6"),
            this.$t("products-dd-6")
          ],
          [
            this.$t("brand"),
            `${this.$t("products-pb-dd9-5")} 40`,
            `${this.$t("products-pb-dd9-5")} 40 - 2`,
            `${this.$t("products-pb-dd9-5")} 50`,
            `${this.$t("products-pb-dd9-5")} 60`
          ],
          [this.$t("elements"), "%", "%", "%", "%"],
          [{ el: "Sn" }, "30 - 40", "39 - 40", "49 - 50", "58 - 60"],
          [{ el: "Sb" }, "1.5 - 2", "-", "-", "-"],
          [
            { el: "Pb" },
            this.$t("products-dd-6"),
            this.$t("products-dd-6"),
            this.$t("products-dd-6"),
            this.$t("products-dd-6")
          ],
          [
            this.$t("brand"),
            `${this.$t("products-pb-dd9-5")} 60 – 0.8`,
            `${this.$t("products-pb-dd9-5")} 66`,
            `${this.$t("products-pb-dd9-5")} 70`,
            `${this.$t("products-pb-dd9-5")} 89`
          ],
          [this.$t("elements"), "%", "%", "%", "%"],
          [{ el: "Sn" }, "58 - 60", "64 - 66", "69 - 71", "87 - 89"],
          [{ el: "Sb" }, "0.8", "-", "-", "-"],
          [
            { el: "Pb" },
            this.$t("products-dd-6"),
            this.$t("products-dd-6"),
            this.$t("products-dd-6"),
            this.$t("products-dd-6")
          ]
          // [
          //   this.$t('brand'),
          //   {
          //     text: `${this.$t('products-pb-dd9-5')} 90`,
          //     colspan: 4
          //   }
          // ],
          //   [
          //     this.$t('elements'),
          //     {
          //       text: '%',
          //       colspan: 4
          //     }
          //   ],
          //   [
          //     { el: 'Sn' },
          //     {
          //       text: '89 - 91',
          //       colspan: 4
          //     }
          //   ],
          //   [
          //     { el: 'Sb' },
          //     {
          //       text: '-',
          //       colspan: 4
          //     }
          //   ],
          //   [
          //     { el: 'Pb' },
          //     {
          //       text: this.$t('products-dd-6'),
          //       colspan: 4
          //     }
          //   ]
        ],
        columns: {
          left: [
            {
              img: require("../../../assets/img/products/pb/dd9.jpg")
            }
          ],
          right: [
            // {
            //   spec: {
            //     title: this.$t("products-dd-1"),
            //     mass: this.$t("products-dd-10"),
            //     left: this.$t("products-dd-3"),
            //     right: this.$t("products-dd-5"),
            //     l: "410 mm",
            //     w: "215 mm",
            //     h: "54 mm"
            //   }
            // },
            {
              title: this.$t("products-pb-dd9-2"),
              texts: [
                this.$t("products-pb-dd9-3"),
                this.$t("products-pb-dd9-4")
              ]
            }
          ]
        }
      };
    },
    facts() {
      return [
        {
          img: require("../../../assets/img/products/pb/if_1.png"),
          text: this.$t("products-pb-if-1")
        },
        {
          img: require("../../../assets/img/products/pb/if_2.png"),
          text: this.$t("products-pb-if-2")
        },
        {
          img: require("../../../assets/img/products/pb/if_3.png"),
          text: this.$t("products-pb-if-3")
        },
        {
          img: require("../../../assets/img/products/pb/if_4.png"),
          text: this.$t("products-pb-if-4")
        },
        {
          img: require("../../../assets/img/products/pb/if_5.png"),
          text: this.$t("products-pb-if-5")
        },
        {
          img: require("../../../assets/img/products/pb/if_6.png"),
          text: this.$t("products-pb-if-6")
        },
        {
          img: require("../../../assets/img/products/pb/if_7.png"),
          text: this.$t("products-pb-if-7")
        },
        {
          img: require("../../../assets/img/products/pb/if_8.png"),
          text: this.$t("products-pb-if-8")
        }
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
.products-individuals-wrapper {
  padding-bottom: 50px;
  .text-group {
    margin: 0 auto;
    padding-top: 40px;
    padding-right: $sidesPadding + $chemicalLarge + ($sidesPadding / 2);
    padding-left: $sidesPadding + $chemicalLarge + ($sidesPadding / 2);
  }
  .content-row {
    padding-right: $sidesPadding + $chemicalLarge + ($sidesPadding / 2);
    padding-left: $sidesPadding + $chemicalLarge + ($sidesPadding / 2);
  }
}
@media screen and (max-width: 1600px) {
  .products-individuals-wrapper {
    .text-group {
      padding-right: $sidesPadding1600 + $chemicalLarge +
        ($sidesPadding1600 / 2);
      padding-left: $sidesPadding1600 + $chemicalLarge + ($sidesPadding1600 / 2);
    }
    .content-row {
      padding-right: $sidesPadding1600 + $chemicalLarge +
        ($sidesPadding1600 / 2);
      padding-left: $sidesPadding1600 + $chemicalLarge + ($sidesPadding1600 / 2);
    }
  }
}
@media screen and (max-width: 1440px) {
  .products-individuals-wrapper {
    .text-group {
      padding-right: $sidesPadding1600 + $chemicalLarge1440 +
        ($sidesPadding1600 / 2);
      padding-left: $sidesPadding1600 + $chemicalLarge1440 +
        ($sidesPadding1600 / 2);
    }
    .content-row {
      padding-right: $sidesPadding1600 + $chemicalLarge1440 +
        ($sidesPadding1600 / 2);
      padding-left: $sidesPadding1600 + $chemicalLarge1440 +
        ($sidesPadding1600 / 2);
    }
  }
}
@media screen and (max-width: 1280px) {
  .products-individuals-wrapper {
    .text-group {
      padding-right: $sidesPadding1280 + $chemicalLarge1440 +
        ($sidesPadding1280 / 2);
      padding-left: $sidesPadding1280 + $chemicalLarge1440 +
        ($sidesPadding1280 / 2);
    }
    .content-row {
      padding-right: $sidesPadding1280 + $chemicalLarge1440 +
        ($sidesPadding1280 / 2);
      padding-left: $sidesPadding1280 + $chemicalLarge1440 +
        ($sidesPadding1280 / 2);
    }
  }
}
@media screen and (max-width: 1000px) {
  .products-individuals-wrapper {
    .text-group {
      padding-right: $sidesPadding1280;
      padding-left: $sidesPadding1280;
    }
    .content-row {
      padding-right: $sidesPadding1280;
      padding-left: $sidesPadding1280;
    }
  }
}
@media screen and (max-width: 600px) {
  .products-individuals-wrapper {
    .text-group {
      padding-right: $sidesPadding600;
      padding-left: $sidesPadding600;
    }
    .content-row {
      padding-right: $sidesPadding600;
      padding-left: $sidesPadding600;
    }
  }
}
</style>

